<div class="row bg-primary text-white py-0 booking-summary">
  <div ngbAccordion
       class="px-0">
    <ng-container *ngFor="let item of parentForm.controls.treatmentAssingments.value; let i=index">
      <div ngbAccordionItem
           [ngbAccordionItem]="item.id"
           [collapsed]="item.isCollapsed">
        <div ngbAccordionHeader
             class="text-white accordion-button bg-primary custom-header justify-content-between align-items-stretch toggleAccordionButton">
          <div class="d-flex flex-column justify-content-between clickable col-5 pt-1"
               (click)="onTreatmentChangeClick()">
            <div class="d-flex flex-md-row align-items-start flex-column pb-3">
              <div class="fw-bolder text-white text-md-end">
                <div class="text-start pe-3 pe-md-5">
                  {{ item.treatment.name }}
                </div>
              </div>
              <div class="pe-3 pe-md-5 text-center">
                <span *ngIf="item.treatment.isDurationVisibleForOnlineBooking">
                  {{ item.treatment.durationInMinutes }}{{ 'SHARED.TIME-UNITS-ABBREV.MINUTES' | translate }}
                </span>
              </div>
              <div class="pe-3 pe-md-5 text-center">
                <span class="small me-1"
                      *ngIf="item.treatment.isPriceInaccurate && item.treatment.isPriceVisibleForOnlineBooking"
                      [translate]="'BOOKING-PART.STEPS-SUMMARY.PRICE-FROM'">
                </span>
                <span class="fw-bold"
                      *ngIf="item.treatment.isPriceVisibleForOnlineBooking">
                  {{ item.treatment.price | currency: 'EUR' }}
                </span>
              </div>
            </div>
            <div class="text-white text-decoration-underline">{{ 'BOOKING-PART.STEPS-SUMMARY.MODIFY' | translate }}</div>
          </div>
          <div ngbAccordionToggle
               class="d-flex flex-column clickable justify-content-between">
            <div class="d-flex align-items-center pb-3">
              <ng-container *ngIf="item.employee">
                <span class="me-2">
                  {{ item.employee.displayName | translate }}
                </span>
                <div [style.background-image]="'url(' + item.employee.photoUrl + '), url(assets/img/placeholder-employee.svg)'"
                     class="specialist-summary-image rounded-circle img-fluid"></div>
                <div>
                </div>
              </ng-container>
              <ng-container *ngIf="!item.employee">
                <span class="me-2">
                  {{ displayNameForAnyEmployee | translate }}
                </span>
                <div [ngStyle]="{ 'background-image': 'url(' + photoUrlForAnyEmployee + ')' }"
                     class="specialist-summary-image rounded-circle img-fluid"></div>
                <div>
                </div>
              </ng-container>
            </div>
            <div class="text-white text-end text-decoration-underline">{{ 'BOOKING-PART.STEPS-SUMMARY.MODIFY' | translate }}</div>
          </div>
        </div>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <app-choose-specialist [assingmentId]="i"
                                     [assignmentsArray]="assignmentsArray"
                                     (triggerAccordionCollapse)="collapseAccordion($event)">
              </app-choose-specialist>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
